export const getUserFirstName = (name?: string | null) => name?.trim().split(/\s+/).filter(Boolean)[0];
export const getUserFirstName = (name?: string | null) => name?.trim().split(/\s+/).filter(Boolean)[0];
